/**
 * @file: 全选
 * @author: xiaolong.huang@dmall.com
 */

import * as SelectToolkit from './toolkit';
import * as CubeTree from '../../cubeTree/index';
import Message from './message';

function all(): void {
    let allCubes: CubeId[] = CubeTree.getAllCube();
    let selectCubes: CubeId[] = allCubes.filter((cubeId: CubeId): boolean => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        return SelectToolkit.canSelect(cube);
    });

    SelectToolkit.addGroup(selectCubes);
    Message.panelSelectAsync();
}

export {
    all
};
